import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import styles from "./VerticalNavbar.module.css";
import { CustomIconButton, Resizer } from "..";
import { setMyReviewRightPanel } from "../../../views/my-review/slice/project-document/project-document-slice";
import { useMyReviewRightPanelWidth } from "../../hooks";
import { getRightPanelMinVw, RIGHT_PANEL_MAX_VW } from "../../hooks/use-review-right-panel-width";

const VerticalNavbar = ({
	mode = "review",
	id = null,
	cautionBannerDisabled = false,
	className = "",
	displayContent = null,
	menus = [],
	menuContentClassName = null,
	onSelectMenu = null,
	open = false,
	position = "right",
	selectedMenu = 0,
	min = 37,
	max = 60,
}) => {
	const reviewWidth = useMyReviewRightPanelWidth();
	const isReview = mode === "review";
	const [localWidth, setLocalWidth] = useState(min);
	const rightPanelWidth = isReview ? reviewWidth : localWidth;
	const minVw = isReview ? getRightPanelMinVw() : min;
	const maxVw = isReview ? RIGHT_PANEL_MAX_VW : max;
	const dispatch = useDispatch();
	const handleResize = (newWidth) => {
		if (isReview) {
			dispatch(setMyReviewRightPanel(newWidth));
		} else {
			setLocalWidth(newWidth);
		}
	};
	return (
		<>
			{open && (
				<Resizer
					isGlobalWidth
					isOnLeft
					additionalPixels={-114}
					className={styles.resizer}
					data-caution-banner-disabled={cautionBannerDisabled}
					idAddition="right"
					max={maxVw}
					min={minVw}
					style={{
						right: `calc(${rightPanelWidth}vw - 114px)`,
					}}
					onResize={handleResize}
				/>
			)}
			<div
				className={`${styles.container} ${className}`}
				data-caution-banner-disabled={cautionBannerDisabled}
				data-open={open}
				data-position={position}
				id={id}
				style={(open && { width: `calc(${rightPanelWidth}vw - 114px)` }) || { width: "49px" }}
			>
				{open && typeof displayContent === "function" && (
					<div className={`${styles.container__menuContent} ${menuContentClassName}`}>{displayContent()}</div>
				)}
				<div className={styles.container__menus}>
					{Array.isArray(menus) &&
						menus.length > 0 &&
						menus
							.filter((m) => !m.disabled)
							.map((menu) => (
								<CustomIconButton
									key={menu.index}
									disableRipple
									badgeClassName={styles.button__badge}
									badgeContent={menu.counter}
									color={selectedMenu === menu.index ? "primary" : "secondary"}
									icon={menu.icon}
									tooltip={menu.name}
									tooltipPlacement="left"
									onClick={() => onSelectMenu(menu.index)}
								/>
							))}
				</div>
			</div>
		</>
	);
};

VerticalNavbar.propTypes = {
	position: PropTypes.oneOf(["right", "left"]),
};

export default VerticalNavbar;
